import {useContext} from 'react'
import BasePathContext from './context'

const useBasePath = (): string | undefined => {
  const {basePath} = useContext(BasePathContext)

  return basePath
}

export default useBasePath
